module.exports = __webpack_public_path__ + "static/media/astro_smb_marketing.5b361fb8.png";